import { ILEGGELSE_SERVICE_BASE_URL } from "../config.ts";

export const GET_ARKIVSAK_SAK_URL = (year, saksnummer) =>
  `${ILEGGELSE_SERVICE_BASE_URL}/arkivsak/saker/${year}/${saksnummer}`;
